var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category-select"},_vm._l((_vm.categories),function(category,key,index){return _c('Category',{key:key,attrs:{"cat-id":key,"text":category.text,"color":_vm.colors[index],"cat-index":index}})}))}
var staticRenderFns = []

export { render, staticRenderFns }